module.exports = __webpack_public_path__ + "img/business.c2055ddd.jpg";